export const SUPPORTED_LOCALES = ['en', 'nl'];
export const DEFAULT_LOCALE = 'nl';

export const en = {
    'app.title': 'Website manager',

    'global.cancel': 'Cancel',
    'global.confirm': 'Confirm',
    'global.overview': 'Overview',
    'global.myPages': 'My Pages',
    'global.logout': 'Logout',
    'global.unexpectedError': "Something went wrong on our end. Your work is safe, so try again in a moment.",
    'global.sessionExpired': "Your session expired for security. Sign in again to pick up where you left off.",
    'global.networkError': "Can't reach the server right now. Check your connection and try again.",

    'login.heading': 'Login',
    'login.headingRegister': 'Register',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.organizationId': 'Organization ID',
    'login.registrationCode': 'Registration code',
    'login.submitLogin': 'Login',
    'login.submitRegister': 'Register',
    'login.toggleToRegister': "Don't have an account? Register",
    'login.toggleToLogin': 'Already have an account? Login',
    'login.loadingLogin': 'Logging in...',
    'login.loadingRegister': 'Creating account...',
    'login.statusLogin': 'Logging you in...',
    'login.statusRegister': 'Creating your account...',
    'login.slowHint': 'Server is waking up. This can take up to 30 seconds.',
    'login.tagline': 'Manage the content of your website.',
    'login.emailPlaceholder': 'you@example.com',
    'login.passwordPlaceholder': 'At least 8 characters',
    'login.organizationIdPlaceholder': 'e.g. acme-corp',
    'login.registrationCodePlaceholder': 'Enter registration code',
    'login.forgotPassword': 'Forgot your password?',
    'login.forgotPasswordHelp': 'Ask the person who built your website for a new password.',

    'templatePicker.loading': 'Loading templates...',
    'templatePicker.welcomePrefix': 'Welcome, ',
    'templatePicker.subtitle': 'Edit your fixed pages or create a new one.',
    'templatePicker.empty': 'No templates set up yet for this site. Ask an admin to add one.',
    'templatePicker.emptyTitle': 'No templates to pick from',
    'templatePicker.defaultDescription': 'Use this template to publish content.',
    'templatePicker.sectionFixed': 'Fixed pages',
    'templatePicker.sectionRepeatable': 'Create a new page',
    'templatePicker.sectionFragments': 'Fragments on other pages',
    'templatePicker.actionEdit': 'Edit',
    'templatePicker.actionCreate': 'Create',
    'templatePicker.actionNewPage': 'New page',
    'templatePicker.actionAdd': 'Add',
    'templatePicker.statusLive': 'Live',
    'templatePicker.statusDraft': 'Draft',
    'templatePicker.statusNotCreated': 'Not created yet',
    'templatePicker.pageCount.one': '1 page',
    'templatePicker.pageCount.other': '{{n}} pages',
    'templatePicker.fragmentCount.one': 'Placed once',
    'templatePicker.fragmentCount.other': 'Placed {{n}} times',

    'pageForm.loadingOverlay': 'Publishing your page...',
    'pageForm.back': '\u2190 Back',
    'pageForm.actionStageDraft': 'Save Draft',
    'pageForm.actionStageEdit': 'Save changes',
    'pageForm.actionPublish': 'Save and publish',
    'pageForm.noChanges': 'No changes to save yet',
    'pageForm.headingCreate': 'New {{name}}',
    'pageForm.headingEdit': 'Edit {{name}}',
    'pageForm.loadingSubmitDraft': 'Saving draft\u2026',
    'pageForm.loadingSubmitEdit': 'Saving changes\u2026',
    'pageForm.loadingData': 'Loading\u2026',
    'pageForm.overlayLoadingData': 'Loading page data\u2026',
    'pageForm.overlaySavingDraft': 'Saving draft\u2026',
    'pageForm.overlayStageEdit': 'Saving your changes\u2026',
    'pageForm.defaultDescription': 'Fill in the fields below to create your page.',
    'pageForm.layoutMap': 'Layout Map',
    'pageForm.carouselOrderTitle': 'Carousel order',
    'pageForm.carouselOrderHint': 'Slides appear in the carousel in this order. Choose a position to move this slide.',
    'pageForm.carouselPosition': 'Slide position',
    'pageForm.layoutNoOverlap': 'All clear — no overlap with other pages.',
    'pageForm.layoutSetPosition': 'Pick a row and column to preview where this page will sit.',
    'pageForm.layoutOutsideRange': 'This position sits outside the preview ({{cols}} cols × {{rows}} rows). Lower the row or column.',
    'pageForm.layoutPinnedOverlap.one': 'Bumping into 1 pinned page. Move this one to a free spot before publishing.',
    'pageForm.layoutPinnedOverlap.other': 'Bumping into {{n}} pinned pages. Move this one to a free spot before publishing.',
    'pageForm.publishBlockedByPinned': 'This page overlaps a pinned page. Move it to a free spot to publish it.',
    'pageForm.layoutAutoShifted.one': '1 page was moved automatically so nothing overlaps.',
    'pageForm.layoutAutoShifted.other': '{{n}} pages were moved automatically so nothing overlaps.',
    'pageForm.layoutAutoShiftedPosition': 'New position: row {{row}}, column {{column}}.',
    'pageForm.layoutOverlap.one': 'Overlapping with 1 page.',
    'pageForm.layoutOverlap.other': 'Overlapping with {{n}} pages.',
    'pageForm.gridHintColumn': 'Column: 1-10 (max 10)',
    'pageForm.gridHintLimited': 'Grid position: 1-{{count}}',
    'pageForm.gridHintWidth': 'Width span: 1-10 (max 10)',
    'pageForm.gridHintRow': 'Row: 1+ (new rows are created automatically)',
    'pageForm.gridHintHeight': 'Height span: 1+ (optional)',
    'pageForm.legendExisting': 'Existing',
    'pageForm.legendCurrent': 'Current',
    'pageForm.legendPinned': 'Pinned',
    'pageForm.legendStaged': 'Staged',
    'pageForm.legendAutoShifted': 'Auto-shifted',
    'pageForm.legendConflict': 'Conflict',
    'pageForm.legendExistingHelp': 'A page that is already published in this section.',
    'pageForm.legendCurrentHelp': 'The page you are editing right now.',
    'pageForm.legendPinnedHelp': 'A page locked to this exact position. Other pages flow around it.',
    'pageForm.legendStagedHelp': 'A draft change that has not been published yet.',
    'pageForm.legendAutoShiftedHelp': 'A page that was automatically moved to avoid an overlap.',
    'pageForm.legendConflictHelp': 'Two pages want the same spot. Move one before publishing.',
    'pageForm.cancel': 'Cancel',
    'pageForm.showPreview': 'Open preview',
    'pageForm.livePreview': 'Live preview',
    'pageForm.previewWide': 'Wide',
    'pageForm.previewDesktop': 'Desktop',
    'pageForm.previewTablet': 'Tablet',
    'pageForm.previewMobile': 'Mobile',
    'pageForm.refresh': 'Update preview',
    'pageForm.hide': 'Close',
    'pageForm.refreshingPreview': 'Refreshing preview...',
    'pageForm.previewPlaceholder': 'Fill in the fields to see a live preview',
    'pageForm.compositionTitle': 'Page content',
    'pageForm.settingsTitle': 'Page settings',
    'pageForm.compositionHint': 'Arrange the sections of this page. Use the arrow buttons, or drag a section by its handle.',
    'pageForm.compositionHintFixed': 'The page blocks are shown in page order. Use the arrows or drag handle to move the sections that allow it.',
    'pageForm.compositionIncompatible': 'The saved section arrangement of this page no longer matches its template. Ask your administrator to update the page before saving.',
    'pageForm.compositionInvalid': 'Some sections are missing content required by their layout.',
    'pageForm.tableRowsRequired': 'Add at least one row to {{label}}.',
    'pageForm.tableCellRequired': 'Fill in {{column}} in row {{n}} of {{label}}.',
    'pageForm.tableCellInvalidNumber': '{{column}} in row {{n}} of {{label}} must be a number.',
    'pageForm.sectionEdit': 'Edit',
    'pageForm.sectionClose': 'Close',
    'pageForm.sectionMoveUp': 'Move {{label}} up',
    'pageForm.sectionMoveDown': 'Move {{label}} down',
    'pageForm.sectionDragHandle': 'Drag to move {{label}}',
    'pageForm.sectionMoved': '{{label}} moved to position {{position}} of {{total}}',
    'pageForm.sectionEnabled': 'Shown',
    'pageForm.sectionDisabled': 'Hidden',
    'pageForm.sectionEmpty': 'Empty',
    'pageForm.sectionLayout': 'Layout',
    'pageForm.sectionAppearance': 'Appearance',
    'pageForm.rowLeft': 'Row {{n}} · left',
    'pageForm.rowRight': 'Row {{n}} · right',
    'pageForm.rowDissolved': 'Row unpaired',
    'pageForm.rowTitle': 'Row {{n}} · side by side',
    'pageForm.rowSplit': 'Split of row {{n}}',
    'pageForm.rowSplitValue': '{{first}} / {{second}}',
    'pageForm.rowSwap': 'Swap sides',
    'pageForm.rowSwapped': 'Sides swapped',
    'pageForm.rowDissolve': 'Unpair',
    'pageForm.pairWithPrevious': 'Place next to the block above',
    'pageForm.addBelow': 'Add block below',
    'pageForm.addBelowQuestion': 'Which block?',
    'pageForm.addBelowCancel': 'Cancel',
    'pageForm.rowPaired': '{{first}} and {{second}} now share a row',
    'pageForm.rowBand': 'Background',
    'pageForm.outlineTitle': 'Page overview',
    'pageForm.outlineJump': 'Go to {{label}}',
    'pageForm.outlineCount.one': '1 block',
    'pageForm.outlineCount.other': '{{n}} blocks',
    'pageForm.sectionNeedsContent': 'This layout needs: {{fields}}',
    'pageForm.sectionNeedsAny': 'This layout needs at least one of: {{fields}}',
    'pageForm.itemAdd': 'Add {{label}}',
    'pageForm.addBlockTitle': 'Add block',
    'pageForm.itemNumbered': '{{label}} {{n}}',
    'pageForm.itemMore': 'More actions for {{label}}',
    'pageForm.itemDuplicate': 'Duplicate',
    'pageForm.itemDelete': 'Delete',
    'pageForm.itemDeleteConfirm': 'Delete {{label}}?',
    'pageForm.itemDeleteCancel': 'Cancel',
    'pageForm.itemMinimum': 'At least {{min}} required',
    'pageForm.itemMaximum': 'At most {{max}} allowed',
    'pageForm.itemAdded': '{{label}} added',
    'pageForm.itemDuplicated': '{{label}} duplicated',
    'pageForm.itemDeleted': '{{label}} deleted',
    'pageForm.selectPlaceholder': 'Choose an option',
    'pageForm.previewOutdated': 'The preview could not be refreshed. Showing the last successful version.',
    'pageForm.previewLinksDisabled': 'Preview links are disabled. Use the published page to navigate.',
    'pageForm.uploadImagePlaceholder': 'Upload an image to preview this template',
    'pageForm.uploadClick': 'Drop an image here or click to browse',
    'pageForm.uploadDrop': 'Drop here to upload',
    'pageForm.uploadReplace': 'Drop a new image here to replace the current one',
    'pageForm.noFileSelected': 'No file selected',
    'pageForm.removeAsset': 'Remove',
    'pageForm.removeAssetLabel': 'Remove {{label}}',
    'pageForm.charCounter': '{{count}} / {{max}} characters',
    'pageForm.charCounterOver': 'longer than recommended',
    'pageForm.currentImage': 'Current image',
    'pageForm.download': 'Download',
    'pageForm.altTextLabel': 'Alt text',
    'pageForm.positionTitle': 'Position',
    'pageForm.imageAltPlaceholder': 'Image description (for screen readers) for {{label}}...',
    'pageForm.focalPoint': 'Focal Point',
    'pageForm.focalPointHint': 'Choose the part that should stay visible when the image is cropped.',
    'pageForm.altTextHint': 'Describe the image for screen readers and search engines.',
    'pageForm.required': '(required)',
    'pageForm.statusNewDraft': 'Draft — not published yet',
    'pageForm.statusEditingLive': 'Draft — pending changes to a live page',
    'pageForm.statusLive': 'Live page',
    'pageForm.statusLiveHelp': 'Change a field and save to create a draft.',
    'pageForm.statusHelp': 'Publish via "Publish All" in My Pages.',
    'pageForm.statusEditingHelp': 'Your changes go live the next time you publish.',
    'pageForm.gridValueInvalid': 'Value is outside the allowed range.',
    'pageForm.inputPlaceholder': 'Enter {{label}}...',
    'pageForm.slugHint': 'This is the part that appears in the page URL.',
    'pageForm.slugPreviewLabel': 'Live URL preview',
    'pageForm.slugMoveWarning': "This page's address will change. Links to the old address will stop working.",

    'coldStart.stage1': 'Connecting to the server…',
    'coldStart.stage2': 'Verifying your credentials…',
    'coldStart.stage3': 'Waking up your workspace…',
    'coldStart.stage4': 'Loading your templates…',
    'coldStart.stage5': 'Preparing the canvas…',
    'coldStart.stage6': 'Ready to launch!',

    'tableField.addRow': 'Add row',
    'tableField.rowCount.one': '1 row',
    'tableField.rowCount.other': '{{n}} rows',
    'tableField.moveUp': 'Move up',
    'tableField.moveDown': 'Move down',
    'tableField.duplicate': 'Duplicate',
    'tableField.deleteRow': 'Delete row',
    'tableField.rowActions': 'Row actions',
    'tableField.dragHandle': 'Drag to reorder',
    'tableField.uploadFile': 'Upload',
    'tableField.replaceFile': 'Replace',
    'tableField.removeFile': 'Remove file',
    'tableField.maxRowsReached': 'Maximum of {{n}} rows reached',
    'tableField.emptyRow': 'Row {{n}}',
    'tableField.empty': 'No rows yet. Add the first one below.',
    'tableField.actionsColumn': 'Actions',
    'tableField.invalidNumber': 'Not a number. Use for example 2 or 2.5.',

    'pageList.loadingOverlay': 'Loading your pages...',
    'pageList.deleting': 'Deleting page...',
    'pageList.preparingPublish': 'Preparing publish job...',
    'pageList.title': 'My pages',
    'pageList.subtitle': 'Edit your pages, view them live or publish your drafts.',
    'pageList.filterLabel': 'Filter by template:',
    'pageList.filterAll': 'All templates',
    'pageList.sortLabel': 'Sort by:',
    'pageList.sortDateDesc': 'Newest first',
    'pageList.sortDateAsc': 'Oldest first',
    'pageList.sortTitleAsc': 'Title A→Z',
    'pageList.sortTitleDesc': 'Title Z→A',
    'pageList.sortTemplate': 'Template',
    'pageList.publishAll': 'Publish All',
    'pageList.publishOne': 'Publish',
    'pageList.conflictWarning': 'Resolve staged layout overlaps before publishing all drafts.',
    'pageList.conflictCheckFailed': 'The layout could not be checked. Try again.',
    'pageList.resolveBeforePublish': 'Resolve staged layout overlaps before publishing.',
    'pageList.conflictCheckFailedPublish': "The layout could not be checked. Click 'Check again' first.",
    'pageList.retryLayoutCheck': 'Check again',
    'pageList.empty': 'No pages yet. Create your first one from the overview.',
    'pageList.emptyTitle': 'Your published pages will live here',
    'pageList.emptyCta': 'Browse templates',
    'pageList.paginationInfo': 'Page {{current}} of {{total}} ({{elements}} total)',
    'pageList.previous': 'Previous',
    'pageList.next': 'Next',
    'pageList.badgeDraft': 'Draft',
    'pageList.badgePendingEdit': 'Changes ready',
    'pageList.badgeLayoutOverlap': 'Layout overlap',
    'pageList.badgePositionMoved': 'Position moved',
    'pageList.homepageBadge': 'Homepage',
    'pageList.edit': 'Edit',
    'pageList.moreActions': 'More actions',
    'pageList.viewLive': 'View live',
    'sitePreview.action': 'View on your website',
    'sitePreview.building': 'Preparing your preview…',
    'sitePreview.slow': 'This is taking longer than usual. Try again later.',
    'sitePreview.ready': 'Ready. Only people with the link can see it.',
    'sitePreview.open': 'Open preview',
    'sitePreview.refresh': 'Refresh preview',
    'sitePreview.readyHint': 'Still the previous version? Reload the page.',
    'sitePreview.failed': 'The preview could not be made. Your drafts are not lost.',
    'sitePreview.noDrafts': 'You have no drafts to view.',
    'sitePreview.noChanges': "Your drafts don't differ from your website.",
    'pageList.statusLive': 'Live',
    'pageList.publishBarTitle': "You have changes that aren't live yet",
    'pageList.publishBarBody': 'Publish them to make them visible on your site.',
    'pageList.discard': 'Discard',
    'pageList.undoEdit': 'Undo edit',
    'pageList.delete': 'Delete',
    'pageList.confirmDeleteTitle': 'Delete "{{title}}"?',
    'pageList.confirmDeleteBody': "The page is removed from your live site immediately. This can't be undone.",
    'pageList.notifyDraftSaved': 'Draft saved. Publish it via "Publish All" to make it live.',
    'pageList.notifyEditStaged': 'Changes saved as draft. Publish via "Publish All" to make them live.',
    'pageList.notifyDraftDiscarded': 'Draft discarded',
    'pageList.notifyEditUndone': 'Edit reverted to original',
    'pageList.notifyPublishedAll': 'All drafts published successfully',
    'pageList.notifyPublishedOne': 'Page published',
    'pageList.notifyPageDeleted': 'Page deleted successfully',
    'pageList.templateAvailabilityUnknown': 'We could not check which templates are already in use, so you might pick a template that is already used.',
    'pageList.progressPublishFailed': "Publishing didn't go through. Your drafts are still here — try again.",
    'pageList.stageQueued': 'Queued — about to start...',
    'pageList.stageOptimizing': 'Optimizing images...',
    'pageList.stageGenerating': 'Generating page HTML...',
    'pageList.stageCreatingPr': 'Creating pull request on GitHub...',
    'pageList.stageMerging': 'Merging changes into your site...',
    'pageList.stageCompleted': 'Published! Refreshing your pages...',
    'pageList.stageFailed': 'Publish failed — your drafts are still saved.',
    'pageList.publishAlreadyRunning': 'A publish is already in progress.',

    'global.retry': 'Try again',
    'global.loadFailedBody': 'Check your connection and try again.',
    'global.account': 'Account menu',
    'global.language': 'Language',
    'notification.close': 'Close message',
    'errors.validation': 'Something needs another look: {{detail}}',
    'errors.badRequest': "Something in the form isn't quite right. Check your input and try again.",
    'errors.forbidden': "You don't have access to this. Ask your administrator if that seems wrong.",
    'errors.notFound': "We couldn't find this anymore. It may have been removed in the meantime.",
    'errors.conflict': "This can't be done right now because another change is in progress. Try again in a moment.",
    'errors.conflictDetail': "This can't be done: {{detail}}",
    'errors.noChanges': "There's nothing new to save: the page already matches what's in the form. Change something first.",
    'errors.noDrafts': 'There are no saved drafts to publish. Save a draft first.',
    'errors.homepageNotDeletable': "The homepage can't be deleted. Edit it instead.",
    'errors.pathTaken': 'A page or draft already uses this address. Choose another slug or title.',
    'errors.assetUpload': 'This file could not be processed. Check that it is a valid image or document.',
    'errors.assetUploadDetail': 'This file could not be processed. Check that it is a valid image or document: {{detail}}',
    'errors.unprocessableDetail': "This couldn't be processed: {{detail}}",
    'errors.tooLarge': 'The upload is too large. Each file can be up to 10 MB, and everything together up to 40 MB.',
    'errors.rateLimited': 'That was a lot of requests in a short time. Wait a minute and try again.',
    'errors.invalidCredentials': "That email and password don't match. Check them and try again.",
    'errors.invalidRegistrationCode': "That registration code isn't valid. Check the code you received.",
    'errors.organizationNotFound': "We don't know that organization ID. Check it and try again.",
    'errors.emailTaken': "There's already an account with this email. Try logging in instead.",
    'templatePicker.loadFailedTitle': "The templates couldn't be loaded",
    'pageList.loadFailedTitle': "Your pages couldn't be loaded",
    'pageList.confirmDiscardTitle': 'Discard the draft "{{title}}"?',
    'pageList.confirmDiscardBody': "Everything in this draft is lost. This can't be undone.",
    'pageList.confirmUndoEditTitle': 'Undo the changes to "{{title}}"?',
    'pageList.confirmUndoEditBody': 'The live page stays as it is, and your unpublished changes are lost.',
    'pageList.confirmPublishTitle': 'Publish your changes?',
    'pageList.confirmPublishBody': 'All your drafts and saved changes go live on your site right away.',
    'pageList.confirmPublishOneTitle': 'Publish "{{title}}"?',
    'pageList.confirmPublishOneBody': 'This page goes live right away. Your other drafts stay drafts.',
    'pageList.confirmPublishAction': 'Publish now',
    'pageList.emptyFilteredTitle': 'No pages found',
    'pageList.emptyFiltered': 'No page matches your search or filter.',
    'pageList.clearFilters': 'Show all pages',
    'pageList.searchLabel': 'Search',
    'pageList.searchPlaceholder': 'Search by title',
    'pageForm.downloadFailed': "The file couldn't be downloaded. Try again in a moment.",
    'pageForm.fieldsNeedAttention': "Some fields still need attention. They're marked below.",
    'pageForm.fieldRequired': 'This field is required.',
    'pageForm.fieldInvalid': "This value isn't valid yet.",
    'pageForm.confirmLeaveTitle': 'Leave without saving?',
    'pageForm.confirmLeaveBody': "Your changes on this page haven't been saved yet and will be lost.",
    'pageForm.confirmLeaveAction': 'Leave page',
    'pageForm.stayAction': 'Keep editing',
    'pageForm.uploadImageLimits': 'JPG, PNG, GIF or WebP, up to 10 MB',
    'pageForm.uploadDocumentLimits': 'Any file up to 10 MB. Images as JPG, PNG, GIF or WebP',
    'pageForm.uploadDocumentImageType': '"{{name}}" is an image format the website can\'t use. Save it as JPG, PNG, GIF or WebP, or as a PDF.',
    'pageForm.uploadTooLarge': '"{{name}}" is {{size}} MB. Files can be up to 10 MB.',
    'pageForm.uploadWrongType': '"{{name}}" isn\'t a supported image. Use JPG, PNG, GIF or WebP.',
    'pageForm.uploadDocumentClick': 'Drop a file here or click to browse',
    'pageForm.previewViewport': 'Preview size',
    'pageForm.imagePreviewAlt': 'Image preview',
    'pageForm.previewFrameTitle': 'Page preview',
    'pageForm.focalLeftTop': 'Top left',
    'pageForm.focalCenterTop': 'Top center',
    'pageForm.focalRightTop': 'Top right',
    'pageForm.focalLeftCenter': 'Middle left',
    'pageForm.focalCenterCenter': 'Center',
    'pageForm.focalRightCenter': 'Middle right',
    'pageForm.focalLeftBottom': 'Bottom left',
    'pageForm.focalCenterBottom': 'Bottom center',
    'pageForm.focalRightBottom': 'Bottom right',
    'tableField.rowDeleted': 'Row {{n}} deleted',
    'tableField.undo': 'Undo',

    'auth.notifyAccountCreated': 'Account created',
};

export const nl = {
    'app.title': 'Websitebeheer',

    'global.cancel': 'Annuleren',
    'global.confirm': 'Bevestigen',
    'global.overview': 'Overzicht',
    'global.myPages': "Mijn pagina's",
    'global.logout': 'Afmelden',
    'global.unexpectedError': "Er ging iets mis aan onze kant. Je werk is veilig, dus probeer het zo opnieuw.",
    'global.sessionExpired': "Je sessie is verlopen voor de veiligheid. Meld je opnieuw aan om verder te gaan.",
    'global.networkError': "Kan de server nu niet bereiken. Controleer je verbinding en probeer opnieuw.",

    'login.heading': 'Aanmelden',
    'login.headingRegister': 'Registreren',
    'login.email': 'E-mailadres',
    'login.password': 'Wachtwoord',
    'login.organizationId': 'Organisatie-ID',
    'login.registrationCode': 'Registratiecode',
    'login.submitLogin': 'Aanmelden',
    'login.submitRegister': 'Registreren',
    'login.toggleToRegister': 'Nog geen account? Registreren',
    'login.toggleToLogin': 'Al een account? Aanmelden',
    'login.loadingLogin': 'Aanmelden...',
    'login.loadingRegister': 'Account aanmaken...',
    'login.statusLogin': 'Bezig met aanmelden...',
    'login.statusRegister': 'Account aanmaken...',
    'login.slowHint': 'De server is aan het opstarten. Dit kan tot 30 seconden duren.',
    'login.tagline': 'Beheer de inhoud van je website.',
    'login.emailPlaceholder': 'jij@voorbeeld.be',
    'login.passwordPlaceholder': 'Minstens 8 tekens',
    'login.organizationIdPlaceholder': 'bv. acme-corp',
    'login.registrationCodePlaceholder': 'Vul je registratiecode in',
    'login.forgotPassword': 'Wachtwoord vergeten?',
    'login.forgotPasswordHelp': 'Vraag je webbouwer om een nieuw wachtwoord.',

    'templatePicker.loading': 'Sjablonen laden...',
    'templatePicker.welcomePrefix': 'Welkom, ',
    'templatePicker.subtitle': "Bewerk je vaste pagina's of maak een nieuwe pagina aan.",
    'templatePicker.empty': 'Er staan nog geen sjablonen klaar voor deze site. Vraag je webbouwer om er een toe te voegen.',
    'templatePicker.emptyTitle': 'Geen sjablonen om uit te kiezen',
    'templatePicker.defaultDescription': 'Gebruik dit sjabloon om inhoud te publiceren.',
    'templatePicker.sectionFixed': "Vaste pagina's",
    'templatePicker.sectionRepeatable': 'Nieuwe pagina maken',
    'templatePicker.sectionFragments': 'Fragmenten op andere pagina\'s',
    'templatePicker.actionEdit': 'Bewerken',
    'templatePicker.actionCreate': 'Aanmaken',
    'templatePicker.actionNewPage': 'Nieuwe pagina',
    'templatePicker.actionAdd': 'Toevoegen',
    'templatePicker.statusLive': 'Live',
    'templatePicker.statusDraft': 'Concept',
    'templatePicker.statusNotCreated': 'Nog niet aangemaakt',
    'templatePicker.pageCount.one': '1 pagina',
    'templatePicker.pageCount.other': "{{n}} pagina's",
    'templatePicker.fragmentCount.one': 'Eén keer geplaatst',
    'templatePicker.fragmentCount.other': '{{n}} keer geplaatst',

    'pageForm.loadingOverlay': 'Pagina publiceren...',
    'pageForm.back': '\u2190 Terug',
    'pageForm.actionStageDraft': 'Concept opslaan',
    'pageForm.actionStageEdit': 'Wijzigingen opslaan',
    'pageForm.actionPublish': 'Opslaan en publiceren',
    'pageForm.noChanges': 'Nog geen wijzigingen om op te slaan',
    'pageForm.headingCreate': 'Nieuw: {{name}}',
    'pageForm.headingEdit': '{{name}} bewerken',
    'pageForm.loadingSubmitDraft': 'Concept opslaan\u2026',
    'pageForm.loadingSubmitEdit': 'Wijzigingen opslaan\u2026',
    'pageForm.loadingData': 'Laden\u2026',
    'pageForm.overlayLoadingData': 'Paginagegevens laden\u2026',
    'pageForm.overlaySavingDraft': 'Concept opslaan\u2026',
    'pageForm.overlayStageEdit': 'Je wijzigingen opslaan\u2026',
    'pageForm.defaultDescription': 'Vul de velden in om de pagina aan te maken.',
    'pageForm.layoutMap': 'Lay-out map',
    'pageForm.carouselOrderTitle': 'Volgorde in de carrousel',
    'pageForm.carouselOrderHint': 'De dia’s verschijnen in deze volgorde in de carrousel. Kies een positie om deze dia te verplaatsen.',
    'pageForm.carouselPosition': 'Positie van deze dia',
    'pageForm.layoutNoOverlap': "Geen overlap — staat vrij van andere pagina's.",
    'pageForm.layoutSetPosition': 'Kies een rij en kolom om te zien waar deze pagina komt.',
    'pageForm.layoutOutsideRange': 'Deze positie valt buiten het voorbeeld ({{cols}} kolommen × {{rows}} rijen). Verlaag rij of kolom.',
    'pageForm.layoutPinnedOverlap.one': 'Botst met 1 gepinde pagina. Verplaats deze naar een vrije plek voordat je publiceert.',
    'pageForm.layoutPinnedOverlap.other': "Botst met {{n}} gepinde pagina's. Verplaats deze naar een vrije plek voordat je publiceert.",
    'pageForm.publishBlockedByPinned': 'Deze pagina botst met een gepinde pagina. Verplaats ze naar een vrije plek om ze te publiceren.',
    'pageForm.layoutAutoShifted.one': '1 pagina is automatisch verschoven zodat er niets overlapt.',
    'pageForm.layoutAutoShifted.other': "{{n}} pagina's zijn automatisch verschoven zodat er niets overlapt.",
    'pageForm.layoutAutoShiftedPosition': 'Nieuwe positie: rij {{row}}, kolom {{column}}.',
    'pageForm.layoutOverlap.one': 'Overlap met 1 pagina.',
    'pageForm.layoutOverlap.other': "Overlap met {{n}} pagina's.",
    'pageForm.gridHintColumn': 'Kolom: 1-10 (max 10)',
    'pageForm.gridHintLimited': 'Gridpositie: 1-{{count}}',
    'pageForm.gridHintWidth': 'Breedte: 1-10 (max 10)',
    'pageForm.gridHintRow': "Rij: 1+ (nieuwe rijen worden automatisch aangemaakt)",
    'pageForm.gridHintHeight': 'Hoogte: 1+ (optioneel)',
    'pageForm.legendExisting': 'Bestaand',
    'pageForm.legendCurrent': 'Huidig',
    'pageForm.legendPinned': 'Gepind',
    'pageForm.legendStaged': 'Concept',
    'pageForm.legendAutoShifted': 'Automatisch verschoven',
    'pageForm.legendConflict': 'Conflict',
    'pageForm.legendExistingHelp': 'Een pagina die al gepubliceerd is in deze sectie.',
    'pageForm.legendCurrentHelp': 'De pagina die je nu bewerkt.',
    'pageForm.legendPinnedHelp': 'Een pagina vastgezet op deze positie. Andere pagina\'s schuiven eromheen.',
    'pageForm.legendStagedHelp': 'Een conceptwijziging die nog niet is gepubliceerd.',
    'pageForm.legendAutoShiftedHelp': 'Een pagina die automatisch is verschoven om overlap te voorkomen.',
    'pageForm.legendConflictHelp': 'Twee pagina\'s willen dezelfde plek. Verplaats er één voordat je publiceert.',
    'pageForm.cancel': 'Annuleren',
    'pageForm.showPreview': 'Voorbeeld openen',
    'pageForm.livePreview': 'Live voorbeeld',
    'pageForm.previewWide': 'Breed',
    'pageForm.previewDesktop': 'Desktop',
    'pageForm.previewTablet': 'Tablet',
    'pageForm.previewMobile': 'Mobiel',
    'pageForm.refresh': 'Voorbeeld bijwerken',
    'pageForm.hide': 'Sluiten',
    'pageForm.refreshingPreview': 'Voorbeeld vernieuwen...',
    'pageForm.previewPlaceholder': 'Vul de velden in voor een live voorbeeld',
    'pageForm.compositionTitle': 'Pagina-inhoud',
    'pageForm.settingsTitle': 'Pagina-instellingen',
    'pageForm.compositionHint': 'Schik de onderdelen van deze pagina. Gebruik de pijlknoppen of sleep een onderdeel aan zijn greep.',
    'pageForm.compositionHintFixed': 'De onderdelen staan in paginavolgorde. Gebruik de pijlen of sleepgreep bij onderdelen die je kan verplaatsen.',
    'pageForm.compositionIncompatible': 'De opgeslagen indeling van deze pagina past niet meer bij haar sjabloon. Vraag je webbouwer om de pagina bij te werken voor je opslaat.',
    'pageForm.compositionInvalid': 'Sommige onderdelen missen inhoud die hun indeling vereist.',
    'pageForm.tableRowsRequired': 'Voeg minstens één rij toe aan {{label}}.',
    'pageForm.tableCellRequired': 'Vul {{column}} in bij rij {{n}} van {{label}}.',
    'pageForm.tableCellInvalidNumber': '{{column}} in rij {{n}} van {{label}} moet een getal zijn.',
    'pageForm.sectionEdit': 'Bewerken',
    'pageForm.sectionClose': 'Sluiten',
    'pageForm.sectionMoveUp': '{{label}} omhoog verplaatsen',
    'pageForm.sectionMoveDown': '{{label}} omlaag verplaatsen',
    'pageForm.sectionDragHandle': 'Sleep om {{label}} te verplaatsen',
    'pageForm.sectionMoved': '{{label}} verplaatst naar positie {{position}} van {{total}}',
    'pageForm.sectionEnabled': 'Zichtbaar',
    'pageForm.sectionDisabled': 'Verborgen',
    'pageForm.sectionEmpty': 'Leeg',
    'pageForm.sectionLayout': 'Indeling',
    'pageForm.sectionAppearance': 'Weergave',
    'pageForm.rowLeft': 'Rij {{n}} · links',
    'pageForm.rowRight': 'Rij {{n}} · rechts',
    'pageForm.rowDissolved': 'Rij opgeheven',
    'pageForm.rowTitle': 'Rij {{n}} · naast elkaar',
    'pageForm.rowSplit': 'Verdeling van rij {{n}}',
    'pageForm.rowSplitValue': '{{first}} / {{second}}',
    'pageForm.rowSwap': 'Wissel van kant',
    'pageForm.rowSwapped': 'Van kant gewisseld',
    'pageForm.rowDissolve': 'Rij opheffen',
    'pageForm.pairWithPrevious': 'Naast vorig blok zetten',
    'pageForm.addBelow': 'Blok hieronder toevoegen',
    'pageForm.addBelowQuestion': 'Welk blok?',
    'pageForm.addBelowCancel': 'Annuleren',
    'pageForm.rowPaired': '{{first}} en {{second}} staan nu naast elkaar',
    'pageForm.rowBand': 'Achtergrond',
    'pageForm.outlineTitle': 'Pagina-overzicht',
    'pageForm.outlineJump': 'Ga naar {{label}}',
    'pageForm.outlineCount.one': '1 blok',
    'pageForm.outlineCount.other': '{{n}} blokken',
    'pageForm.sectionNeedsContent': 'Deze indeling vraagt: {{fields}}',
    'pageForm.sectionNeedsAny': 'Deze indeling vraagt minstens één van: {{fields}}',
    'pageForm.itemAdd': '{{label}} toevoegen',
    'pageForm.addBlockTitle': 'Blok toevoegen',
    'pageForm.itemNumbered': '{{label}} {{n}}',
    'pageForm.itemMore': 'Meer acties voor {{label}}',
    'pageForm.itemDuplicate': 'Dupliceren',
    'pageForm.itemDelete': 'Verwijderen',
    'pageForm.itemDeleteConfirm': '{{label}} verwijderen?',
    'pageForm.itemDeleteCancel': 'Annuleren',
    'pageForm.itemMinimum': 'Minstens {{min}} nodig',
    'pageForm.itemMaximum': 'Maximaal {{max}} toegestaan',
    'pageForm.itemAdded': '{{label}} toegevoegd',
    'pageForm.itemDuplicated': '{{label}} gedupliceerd',
    'pageForm.itemDeleted': '{{label}} verwijderd',
    'pageForm.selectPlaceholder': 'Kies een optie',
    'pageForm.previewOutdated': 'Het voorbeeld kon niet worden vernieuwd. Dit is de laatste geslaagde versie.',
    'pageForm.previewLinksDisabled': 'Links in het voorbeeld zijn uitgeschakeld. Gebruik de gepubliceerde pagina om te navigeren.',
    'pageForm.uploadImagePlaceholder': 'Upload een afbeelding om dit sjabloon te bekijken',
    'pageForm.uploadClick': 'Sleep hier een afbeelding of klik om te bladeren',
    'pageForm.uploadDrop': 'Laat hier los om te uploaden',
    'pageForm.uploadReplace': 'Sleep hier een nieuwe afbeelding om de huidige te vervangen',
    'pageForm.noFileSelected': 'Geen bestand geselecteerd',
    'pageForm.removeAsset': 'Verwijderen',
    'pageForm.removeAssetLabel': '{{label}} verwijderen',
    'pageForm.charCounter': '{{count}} / {{max}} tekens',
    'pageForm.charCounterOver': 'langer dan aanbevolen',
    'pageForm.currentImage': 'Huidige afbeelding',
    'pageForm.download': 'Downloaden',
    'pageForm.altTextLabel': 'Alt-tekst',
    'pageForm.positionTitle': 'Positie',
    'pageForm.imageAltPlaceholder': 'Afbeeldingsbeschrijving (voor schermlezers) voor {{label}}...',
    'pageForm.focalPoint': 'Focuspunt',
    'pageForm.focalPointHint': 'Kies het deel dat zichtbaar moet blijven als de afbeelding wordt bijgesneden.',
    'pageForm.altTextHint': 'Beschrijf de afbeelding voor schermlezers en zoekmachines.',
    'pageForm.required': '(verplicht)',
    'pageForm.statusNewDraft': 'Concept — nog niet gepubliceerd',
    'pageForm.statusEditingLive': 'Concept — wijzigt live pagina',
    'pageForm.statusLive': 'Live pagina',
    'pageForm.statusLiveHelp': 'Pas een veld aan en sla op om een concept te maken.',
    'pageForm.statusHelp': 'Publiceer via "Alles publiceren" in Mijn pagina\'s.',
    'pageForm.statusEditingHelp': 'Je wijzigingen gaan live bij de volgende publicatie.',
    'pageForm.gridValueInvalid': 'Waarde valt buiten het toegestane bereik.',
    'pageForm.inputPlaceholder': 'Voer {{label}} in...',
    'pageForm.slugHint': 'Dit is het deel dat in de URL van de pagina verschijnt.',
    'pageForm.slugPreviewLabel': 'Live URL-voorbeeld',
    'pageForm.slugMoveWarning': 'Het adres van deze pagina verandert. Links naar het oude adres werken daarna niet meer.',

    'coldStart.stage1': 'Verbinden met de server…',
    'coldStart.stage2': 'Aanmeldgegevens controleren…',
    'coldStart.stage3': 'De server opstarten…',
    'coldStart.stage4': 'Je sjablonen ophalen…',
    'coldStart.stage5': 'Alles klaarzetten…',
    'coldStart.stage6': 'Klaar!',

    'tableField.addRow': 'Rij toevoegen',
    'tableField.rowCount.one': '1 rij',
    'tableField.rowCount.other': '{{n}} rijen',
    'tableField.moveUp': 'Omhoog',
    'tableField.moveDown': 'Omlaag',
    'tableField.duplicate': 'Dupliceren',
    'tableField.deleteRow': 'Rij verwijderen',
    'tableField.rowActions': 'Rijacties',
    'tableField.dragHandle': 'Sleep om te verplaatsen',
    'tableField.uploadFile': 'Uploaden',
    'tableField.replaceFile': 'Vervangen',
    'tableField.removeFile': 'Bestand verwijderen',
    'tableField.maxRowsReached': 'Maximum van {{n}} rijen bereikt',
    'tableField.emptyRow': 'Rij {{n}}',
    'tableField.empty': 'Nog geen rijen. Voeg hieronder de eerste toe.',
    'tableField.actionsColumn': 'Acties',
    'tableField.invalidNumber': 'Geen getal. Gebruik bijvoorbeeld 2 of 2.5.',

    'pageList.loadingOverlay': "Pagina's laden...",
    'pageList.deleting': 'Pagina verwijderen...',
    'pageList.preparingPublish': 'Publicatie voorbereiden...',
    'pageList.title': "Mijn pagina's",
    'pageList.subtitle': "Bewerk je pagina's, bekijk ze live of publiceer je concepten.",
    'pageList.filterLabel': 'Filteren op sjabloon:',
    'pageList.filterAll': 'Alle sjablonen',
    'pageList.sortLabel': 'Sorteren op:',
    'pageList.sortDateDesc': 'Nieuwste eerst',
    'pageList.sortDateAsc': 'Oudste eerst',
    'pageList.sortTitleAsc': 'Titel A→Z',
    'pageList.sortTitleDesc': 'Titel Z→A',
    'pageList.sortTemplate': 'Sjabloon',
    'pageList.publishAll': 'Alles publiceren',
    'pageList.publishOne': 'Publiceren',
    'pageList.conflictWarning': "Los de lay-outconflicten op voordat je alle concepten publiceert.",
    'pageList.conflictCheckFailed': 'De lay-out kon niet gecontroleerd worden. Probeer opnieuw.',
    'pageList.resolveBeforePublish': 'Los de lay-outconflicten op voordat je publiceert.',
    'pageList.conflictCheckFailedPublish': "De lay-out kon niet gecontroleerd worden. Klik eerst op 'Opnieuw controleren'.",
    'pageList.retryLayoutCheck': 'Opnieuw controleren',
    'pageList.empty': "Nog geen pagina's. Maak je eerste pagina aan vanuit het overzicht.",
    'pageList.emptyTitle': "Hier komen je gepubliceerde pagina's",
    'pageList.emptyCta': 'Bekijk sjablonen',
    'pageList.paginationInfo': 'Pagina {{current}} van {{total}} ({{elements}} totaal)',
    'pageList.previous': 'Vorige',
    'pageList.next': 'Volgende',
    'pageList.badgeDraft': 'Concept',
    'pageList.badgePendingEdit': 'Wijziging klaar',
    'pageList.badgeLayoutOverlap': 'Lay-outconflict',
    'pageList.badgePositionMoved': 'Positie gewijzigd',
    'pageList.homepageBadge': 'Homepagina',
    'pageList.edit': 'Bewerken',
    'pageList.moreActions': 'Meer acties',
    'pageList.viewLive': 'Bekijk live',
    'sitePreview.action': 'Bekijk op je website',
    'sitePreview.building': 'Je voorbeeld wordt klaargemaakt…',
    'sitePreview.slow': 'Het duurt langer dan normaal. Probeer het later opnieuw.',
    'sitePreview.ready': 'Klaar. Enkel wie de link heeft, ziet het.',
    'sitePreview.open': 'Voorbeeld openen',
    'sitePreview.refresh': 'Voorbeeld vernieuwen',
    'sitePreview.readyHint': 'Nog de vorige versie? Vernieuw de pagina.',
    'sitePreview.failed': 'Het voorbeeld kon niet gemaakt worden. Je concepten zijn niet verloren.',
    'sitePreview.noDrafts': 'Je hebt geen concepten om te bekijken.',
    'sitePreview.noChanges': 'Je concepten verschillen niet van je website.',
    'pageList.statusLive': 'Live',
    'pageList.publishBarTitle': 'Je hebt wijzigingen die nog niet live staan',
    'pageList.publishBarBody': 'Publiceer ze om ze zichtbaar te maken op je site.',
    'pageList.discard': 'Concept verwijderen',
    'pageList.undoEdit': 'Bewerking ongedaan maken',
    'pageList.delete': 'Pagina verwijderen',
    'pageList.confirmDeleteTitle': '"{{title}}" verwijderen?',
    'pageList.confirmDeleteBody': "De pagina verdwijnt meteen van je live site. Dit kan je niet ongedaan maken.",
    'pageList.notifyDraftSaved': 'Concept opgeslagen. Publiceer het via "Alles publiceren" om het live te zetten.',
    'pageList.notifyEditStaged': "Wijzigingen opgeslagen als concept. Publiceer via \"Alles publiceren\" om ze live te zetten.",
    'pageList.notifyDraftDiscarded': 'Concept verwijderd',
    'pageList.notifyEditUndone': 'Bewerking ongedaan gemaakt',
    'pageList.notifyPublishedAll': 'Alle concepten succesvol gepubliceerd',
    'pageList.notifyPublishedOne': 'Pagina gepubliceerd',
    'pageList.notifyPageDeleted': 'Pagina succesvol verwijderd',
    'pageList.templateAvailabilityUnknown': 'We konden niet nagaan welke sjablonen al in gebruik zijn. Je kan daardoor misschien een sjabloon kiezen dat al gebruikt is.',
    'pageList.progressPublishFailed': "Publiceren is niet gelukt. Je concepten staan er nog — probeer het opnieuw.",
    'pageList.stageQueued': 'In wachtrij — start zo dadelijk...',
    'pageList.stageOptimizing': "Afbeeldingen optimaliseren...",
    'pageList.stageGenerating': "Pagina's opmaken...",
    'pageList.stageCreatingPr': 'Wijzigingen klaarzetten...',
    'pageList.stageMerging': 'Wijzigingen op je website zetten...',
    'pageList.stageCompleted': "Gepubliceerd! Pagina's vernieuwen...",
    'pageList.stageFailed': 'Publiceren mislukt — je concepten staan er nog.',
    'pageList.publishAlreadyRunning': 'Er wordt al gepubliceerd.',

    'global.retry': 'Opnieuw proberen',
    'global.loadFailedBody': 'Controleer je verbinding en probeer het opnieuw.',
    'global.account': 'Accountmenu',
    'global.language': 'Taal',
    'notification.close': 'Melding sluiten',
    'errors.validation': 'Er moet nog iets aangepast worden: {{detail}}',
    'errors.badRequest': 'Er klopt iets niet in het formulier. Kijk je invoer na en probeer het opnieuw.',
    'errors.forbidden': 'Je hebt hier geen toegang toe. Vraag het na bij je webbouwer als dat niet klopt.',
    'errors.notFound': 'We vinden dit niet meer terug. Misschien is het intussen verwijderd.',
    'errors.conflict': 'Dit lukt nu even niet omdat er al een andere wijziging bezig is. Probeer het zo opnieuw.',
    'errors.conflictDetail': 'Dit kan niet: {{detail}}',
    'errors.noChanges': 'Er is niets nieuws om op te slaan: de pagina komt al overeen met wat in het formulier staat. Pas eerst iets aan.',
    'errors.noDrafts': 'Er zijn geen opgeslagen concepten om te publiceren. Sla eerst een concept op.',
    'errors.homepageNotDeletable': 'De homepagina kan je niet verwijderen. Pas ze in de plaats aan.',
    'errors.pathTaken': 'Er bestaat al een pagina of concept met dit adres. Kies een andere slug of titel.',
    'errors.assetUpload': 'Dit bestand kon niet verwerkt worden. Kijk na of het een geldige afbeelding of een geldig document is.',
    'errors.assetUploadDetail': 'Dit bestand kon niet verwerkt worden. Kijk na of het een geldige afbeelding of een geldig document is: {{detail}}',
    'errors.unprocessableDetail': 'Dit kon niet verwerkt worden: {{detail}}',
    'errors.tooLarge': 'De upload is te groot. Elk bestand mag maximaal 10 MB zijn, en alles samen maximaal 40 MB.',
    'errors.rateLimited': 'Dat waren veel verzoeken in korte tijd. Wacht even een minuutje en probeer het opnieuw.',
    'errors.invalidCredentials': 'Dit e-mailadres en wachtwoord horen niet bij elkaar. Kijk ze na en probeer het opnieuw.',
    'errors.invalidRegistrationCode': 'Deze registratiecode is niet geldig. Kijk de code na die je gekregen hebt.',
    'errors.organizationNotFound': 'We kennen deze organisatie-ID niet. Kijk hem na en probeer het opnieuw.',
    'errors.emailTaken': 'Er bestaat al een account met dit e-mailadres. Meld je in de plaats aan.',
    'templatePicker.loadFailedTitle': 'De sjablonen konden niet geladen worden',
    'pageList.loadFailedTitle': "Je pagina's konden niet geladen worden",
    'pageList.confirmDiscardTitle': 'Het concept "{{title}}" verwijderen?',
    'pageList.confirmDiscardBody': 'Alles in dit concept gaat verloren. Dit kan je niet ongedaan maken.',
    'pageList.confirmUndoEditTitle': 'De wijzigingen aan "{{title}}" ongedaan maken?',
    'pageList.confirmUndoEditBody': 'De live pagina blijft zoals ze is, en je niet-gepubliceerde wijzigingen gaan verloren.',
    'pageList.confirmPublishTitle': 'Je wijzigingen publiceren?',
    'pageList.confirmPublishBody': 'Al je concepten en opgeslagen wijzigingen komen meteen live op je site.',
    'pageList.confirmPublishOneTitle': '"{{title}}" publiceren?',
    'pageList.confirmPublishOneBody': 'Deze pagina komt meteen live op je site. Je andere concepten blijven concepten.',
    'pageList.confirmPublishAction': 'Nu publiceren',
    'pageList.emptyFilteredTitle': "Geen pagina's gevonden",
    'pageList.emptyFiltered': 'Geen enkele pagina past bij je zoekopdracht of filter.',
    'pageList.clearFilters': "Alle pagina's tonen",
    'pageList.searchLabel': 'Zoeken',
    'pageList.searchPlaceholder': 'Zoek op titel',
    'pageForm.downloadFailed': 'Het bestand kon niet gedownload worden. Probeer het zo opnieuw.',
    'pageForm.fieldsNeedAttention': 'Enkele velden vragen nog aandacht. Je vindt ze hieronder gemarkeerd.',
    'pageForm.fieldRequired': 'Dit veld is verplicht.',
    'pageForm.fieldInvalid': 'Deze waarde is nog niet geldig.',
    'pageForm.confirmLeaveTitle': 'Weggaan zonder op te slaan?',
    'pageForm.confirmLeaveBody': 'Je wijzigingen op deze pagina zijn nog niet opgeslagen en gaan verloren.',
    'pageForm.confirmLeaveAction': 'Pagina verlaten',
    'pageForm.stayAction': 'Verder bewerken',
    'pageForm.uploadImageLimits': 'JPG, PNG, GIF of WebP, maximaal 10 MB',
    'pageForm.uploadDocumentLimits': 'Elk bestand tot 10 MB. Afbeeldingen als JPG, PNG, GIF of WebP',
    'pageForm.uploadDocumentImageType': '"{{name}}" is een afbeeldingsformaat dat de website niet kan gebruiken. Bewaar het als JPG, PNG, GIF of WebP, of als PDF.',
    'pageForm.uploadTooLarge': '"{{name}}" is {{size}} MB. Bestanden mogen maximaal 10 MB zijn.',
    'pageForm.uploadWrongType': '"{{name}}" is geen ondersteunde afbeelding. Gebruik JPG, PNG, GIF of WebP.',
    'pageForm.uploadDocumentClick': 'Sleep hier een bestand of klik om te bladeren',
    'pageForm.previewViewport': 'Voorbeeldformaat',
    'pageForm.imagePreviewAlt': 'Voorbeeld van de afbeelding',
    'pageForm.previewFrameTitle': 'Voorbeeld van de pagina',
    'pageForm.focalLeftTop': 'Linksboven',
    'pageForm.focalCenterTop': 'Midden boven',
    'pageForm.focalRightTop': 'Rechtsboven',
    'pageForm.focalLeftCenter': 'Links in het midden',
    'pageForm.focalCenterCenter': 'Midden',
    'pageForm.focalRightCenter': 'Rechts in het midden',
    'pageForm.focalLeftBottom': 'Linksonder',
    'pageForm.focalCenterBottom': 'Midden onder',
    'pageForm.focalRightBottom': 'Rechtsonder',
    'tableField.rowDeleted': 'Rij {{n}} verwijderd',
    'tableField.undo': 'Ongedaan maken',

    'auth.notifyAccountCreated': 'Account aangemaakt',
};
